import type { VideoSpecsOption, VideoSpecsOptions, VideoSpecsValue } from "./types";

export const DEFAULT_VIDEO_SPECS_VALUE: VideoSpecsValue = {
  aspectRatio: "RATIO_9_16",
  resolution: "720P",
};

export const isSameVideoSpecsValue = (left: VideoSpecsValue, right: VideoSpecsValue) =>
  left.aspectRatio === right.aspectRatio && left.resolution === right.resolution;

const resolveValue = (
  options: VideoSpecsOption<string>[],
  current: string | undefined,
  apiDefault: string | undefined,
  preferApiDefault: boolean,
): string | undefined => {
  const apiDefaultInOptions =
    apiDefault && options.some((option) => option.value === apiDefault) ? apiDefault : undefined;
  if (preferApiDefault && apiDefaultInOptions) return apiDefaultInOptions;
  if (current && options.some((option) => option.value === current)) return current;
  return apiDefaultInOptions ?? options[0]?.value;
};

export const normalizeVideoSpecs = (
  value: Partial<VideoSpecsValue> | undefined,
  options: VideoSpecsOptions | null,
  preferApiDefault = false,
): VideoSpecsValue => {
  const next: VideoSpecsValue = { ...DEFAULT_VIDEO_SPECS_VALUE, ...value };
  if (!options) return next;

  const { aspectRatioOptions, resolutionOptions, defaultAspectRatio, defaultResolution } = options;

  if (aspectRatioOptions.length) {
    next.aspectRatio =
      resolveValue(aspectRatioOptions, next.aspectRatio, defaultAspectRatio, preferApiDefault) ?? next.aspectRatio;
  }
  if (resolutionOptions.length) {
    next.resolution =
      resolveValue(resolutionOptions, next.resolution, defaultResolution, preferApiDefault) ?? next.resolution;
  }

  return next;
};
